import Swiper from 'swiper';
import { Pagination, EffectFade } from 'swiper/modules';
import { whenElementReady } from '../../../../application/typescript/utils/utils';

class FormQuizz {
  constructor() {
    this._init();
  }

  _init() {
    whenElementReady('.form-quizz__swiper', () => {
      // Init Swiper
      const swiper = new Swiper('.form-quizz__swiper', {
        modules: [Pagination, EffectFade],
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        grabCursor: false,
        mousewheel: false,
        preventInteractionOnTransition: true,
        pagination: {
          el: ".swiper-pagination",
          // clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
          },
        },
      });
      swiper.disable();

      // Button : Disabled
      document.querySelectorAll('.form-quizz__reponse-input').forEach(input => {
        input.addEventListener('change', (event) => {
          const currentSlide = swiper.slides[swiper.activeIndex];
          const nextButton = currentSlide.querySelector('button');

          if (nextButton) {
            nextButton.disabled = !currentSlide.querySelector('input[type="radio"]:checked');
          }
        });
      });

      // Next Button : Click
      const nextButtons = document.querySelectorAll('[data-quizz-next]');

      if (nextButtons.length > 0) {
        nextButtons.forEach(button => {
          button.addEventListener('click', (event: Event) => {
            event.preventDefault();
            const btn = button as HTMLButtonElement;

            if (!btn.disabled) {
              swiper.enable();
              swiper.slideNext();
              swiper.disable();
            } else {
              console.log("erro")
            }
          });
        });
      }
    });
  }
}

export const formQuizz = new FormQuizz();
